var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17478",
    transform: "translate(229.521 228.815)",
    fill: "#751bdc",
    stroke: "#707070",
    d: "M0 0h16v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1479",
    transform: "translate(-229.521 -228.815)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17479",
    fill: "none",
    d: "M229.521 228.815h16v16h-16z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37409",
    fill: "#751bdc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21710",
    d: "M237.522 237.439a4.8 4.8 0 0 1 1.143-3.136.653.653 0 0 0-.98-.849 5.945 5.945 0 0 0-1.47 3.985 6.01 6.01 0 0 0 1.47 4.083.719.719 0 0 0 .49.2.784.784 0 0 0 .457-.163.719.719 0 0 0 .033-.947 4.638 4.638 0 0 1-1.143-3.173Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21711",
    d: "M243.237 233.45a.653.653 0 0 0-.98.849 4.8 4.8 0 0 1 1.144 3.14 4.638 4.638 0 0 1-1.143 3.168.719.719 0 0 0 .033.947.784.784 0 0 0 .457.163.719.719 0 0 0 .49-.2 6.01 6.01 0 0 0 1.469-4.078 5.945 5.945 0 0 0-1.47-3.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21712",
    d: "m242.323 239.068-1.078-1.6 1.078-1.6a.662.662 0 0 0-1.111-.719l-.751 1.143-.751-1.143a.662.662 0 1 0-1.111.719l1.078 1.6-1.078 1.6a.686.686 0 0 0 .2.915.653.653 0 0 0 .359.1.686.686 0 0 0 .555-.294l.751-1.143.751 1.143a.686.686 0 0 0 .555.294.653.653 0 0 0 .359-.1.686.686 0 0 0 .2-.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21713",
    d: "M235.561 233.875h-.719l.163-1.143a1.274 1.274 0 0 1 1.275-1.143h.588a.653.653 0 0 0 0-1.307h-.588a2.646 2.646 0 0 0-2.581 2.254l-.2 1.339h-.881a.653.653 0 0 0 0 1.307h.719l-.817 5.716a1.274 1.274 0 0 1-1.274 1.143h-.258a.653.653 0 0 0 0 1.307h.261a2.646 2.646 0 0 0 2.581-2.254l.817-5.912h.915a.653.653 0 1 0 0-1.307Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFx);
export default __webpack_public_path__ + "static/media/FX.9240f1c1915c609fbc884ec7f4abbbbd.svg";
export { ForwardRef as ReactComponent };